<template>
  <div class="nav_menu_list">
    <el-menu :router="true" :default-active="defaultPath" @select="handleOpen">
      <div v-for="(item,index) in menuList">
        <template v-if="item.children?.length>0">
          <el-submenu :index="item.path">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </template>
            <el-menu-item v-for="(child,ci) in item.children" :key="ci" :index="child.path">
              {{ child.title }}
            </el-menu-item>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.path">
            <i :class="item.icon"></i>
            {{ item.title }}
          </el-menu-item>
        </template>
      </div>
    </el-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      defaultPath: '',
      menuList: [
        {
          title: '首页总览',
          icon: 'el-icon-house',
          path: '/'
        },
        {
          title: '商家管理',
          path: '1',
          icon: 'el-icon-suitcase',
          children: [
            {
              title: '商家列表',
              path: '/BusinessList'
            },
            {
              title: '交易明细记录',
              path: '/TransactionList'
            },
            {
              title: '账户结算记录',
              path: '/SettlementList'
            },
            {
              title: '商家会员管理',
              path: '/MemberList'
            },

          ]
        },
        {
          title: '代理商管理',
          path: '2',
          icon: 'el-icon-postcard',
          children: [
            {
              title: '代理商列表',
              path: '/AgentList'
            },
            {
              title: '跨界收入记录',
              path: '/IncomeList'
            },
            {
              title: '账户结算列表',
              path: '/SettList'
            },
          ]
        },
        {
          title: '订单管理',
          path: '3',
          icon: 'el-icon-chat-line-square',
          children: [
            {
              title: '订单列表',
              path: '/OrderList'
            },
          ]
        },
        {
          title: '公告管理',
          path: '4',
          icon: 'el-icon-chat-line-square',
          children: [
            {
              title: '公告列表',
              path: '/NoticeList'
            },
          ]
        },
        {
          title: '城市合伙人服务点',
          path: '5',
          icon: 'el-icon-place',
          children: [
            {
              title: '服务点列表',
              path: '/PartnerList'
            },
          ]
        },
      ]
    }
  },
  mounted() {
    this.defaultPath = localStorage.getItem('activePath') || ''
  },
  methods: {
    handleOpen(e) {
      console.log(111, e)
      localStorage.setItem('activePath', e)
    }
  }
}
</script>
<style lang='scss' scoped>
.nav_menu_list {
  height: calc(100vh - 50px);
  width: 200px;
  background-color: #fff;

  /deep/ .el-menu {
    border: none;
  }
}
</style>